import React from "react";
import "./css/SocialMediaIcons.css";

const SocialMediaIcons = () => {
  return (        
    <div className="social-media-icons">  
      <a href="https://github.com/raphaelmayer" target="_blank" rel="noopener noreferrer" ><i className='fab fa-github'></i></a>
      <a href="https://www.linkedin.com/in/raphael-mayer" target="_blank" rel="noopener noreferrer" ><i className='fab fa-linkedin'></i></a>
    </div>
  );
}

export default SocialMediaIcons;